import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReassignParams } from "../../../domain/entities/all-deliveries";
import { type AllDeliveriesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const reassign = createAsyncThunk<
  void,
  ReassignParams,
  { dispatch: AllDeliveriesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.REASSIGN, async (params, { extra }) => {
  await extra.allDeliveriesRepo.reassign(params);
});
